import { StatusPageAlert } from './statuspage';

export type GetStatusPageAlertsQueryPayload = {};
export type GetStatusPageAlertsQueryResult = {
  status_alerts: StatusPageAlert[];
  is_whitelabel_user: boolean;
};
